// Shared YouTube IFrame API loader — single instance across all components
let loaded = false;
let ready = false;
let failed = false;
const callbacks: Array<() => void> = [];

export function loadYTApi(cb: () => void) {
  if (ready) { cb(); return; }
  if (failed) { cb(); return; } // call cb even on failure so callers can reset loading state
  callbacks.push(cb);
  if (loaded) return;
  loaded = true;
  window.onYouTubeIframeAPIReady = () => {
    ready = true;
    callbacks.forEach(fn => fn());
    callbacks.length = 0;
  };
  const tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';
  tag.onerror = () => {
    failed = true;
    callbacks.length = 0;
  };
  document.head.appendChild(tag);

  // Fallback: if API doesn't fire within 10s, mark as failed so loading spinners don't hang
  setTimeout(() => {
    if (!ready) {
      failed = true;
      callbacks.length = 0;
    }
  }, 10000);
}
